import { showAlert } from './ErrorMessage';

export const backgroundColor = 'black';
export const redColor = 'red';
export const whiteColor = 'white';
export const greenColor = 'green';
export const orangeColor = 'orange';
export const grayColor = 'gray';
export const lightgrayColor = '#d9d9d9';
export const redBoxColor = '#E31E24';
export const blueBoxColor = '#85BDF9';
export const gray95BoxColor = '#f2f2f2';
export const FABRICUSER = 'Fabric';
export const GARMENTUSER = 'Garment';
export const PPC = '2';
export const IMMEDIATE = '1';
export const DIVISION = 14;
export const RATIO100 = 1;
export const RATIO75 = 2;
export const RATIO50 = 3;
export const RATIO25 = 4;
export const AppName = "Siyaram's";

// export const getLocation = async () => {
//   try {
//     // Assuming the static latitude, longitude, and address
//     const latitude = 19.0808064; // New York City latitude
//     const longitude = 72.8334336; // New York City longitude
//     const address = "Talmaki Road, Willingdon, H/W Ward, Zone 3, Mumbai, Maharashtra, 400054, India";

//     // Set the static location data to localStorage
//     localStorage.setItem("location", JSON.stringify({ latitude, longitude, address }));

//   } catch (error) {
//     console.error('Error setting static location:', error.message);
//   }
// };

// export const checkGeolocationStatus = () => {
//   return new Promise((resolve) => {
//     // Assuming geolocation is always enabled in this scenario
//     // You can directly call getLocation since it's static
//     getLocation();
//     resolve(true);
//   });
// };

export const getLocation = async () => {
  try {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;

        // Use OpenStreetMap Nominatim for reverse geocoding
        const reverseGeocodingUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
        const response = await fetch(reverseGeocodingUrl);
        if (response.ok) {
          const data = await response.json();
          const address = data.display_name;
          localStorage.setItem('location', JSON.stringify({ latitude, longitude, address }));
        } else {
          // console.error('Failed to fetch data:', response.status);
        }
      });
    } else {
      // console.error('Geolocation is not supported by your browser.');
    }
  } catch (error) {
    // console.error('Error getting location:', error.message);
  }
};

export const checkGeolocationStatus = () => {
  return new Promise((resolve) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        () => {
          // console.log(position);
          // Geolocation is enabled
          resolve(true);
          getLocation();
        },
        () => {
          // Geolocation is disabled or user denied the request
          // console.error('Geolocation is disabled or denied'+error);
          resolve(false);
        }
      );
      // console.log(reject);
      // console.log(navigator.geolocation.getCurrentPosition);
    } else {
      // Geolocation is not supported by the browser
      // console.error('Geolocation is not supported by your browser');
      resolve(false);
    }
  });
};

export const getLocationLogin = async () => {
  if (!navigator.geolocation) {
    showAlert('Geolocation not supported by browser', 'Validation');
    return;
  }

  const geoOptions = {
    enableHighAccuracy: false,
    timeout: 10000,        // 10 sec max wait
    maximumAge: 300000,    // 5 min cache
  };

  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        reject,
        geoOptions
      );
    });

    const { latitude, longitude } = position.coords;

    // ✅ STEP 1: Always save lat/long (MOST IMPORTANT)
    localStorage.setItem(
      'location',
      JSON.stringify({ latitude, longitude, address: '' })
    );

  } catch (error) {
    console.error(error);
    // switch (error.code) {
    //   case error.PERMISSION_DENIED:
    //     showAlert('Please enable location permission', 'Validation');
    //     break;
    //   case error.POSITION_UNAVAILABLE:
    //     showAlert('Location unavailable on this network', 'Validation');
    //     break;
    //   case error.TIMEOUT:
    //     showAlert('Location request timed out. Try again.', 'Validation');
    //     break;
    //   default:
    //     showAlert('Unable to fetch location', 'Validation');
    // }
  }
};


export const getPositionsForBeat = async () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;

          // Reverse geocoding
          const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
          const response = await fetch(url);
          let address = '';
          if (response.ok) {
            const data = await response.json();
            address = data.display_name;
          }

          // Save to localStorage (optional)
          localStorage.setItem('location', JSON.stringify({ latitude, longitude, address }));

          resolve({ latitude, longitude, address });
        } catch (err) {
          reject(err);
        }
      },
      (error) => {
        reject(error);
      }
    );
  });
};

// Ration feature configuration
export const ratioFeature = {
  allowedUserVerticals: ['Garment'],
  // allowedConfSparts: ['O2', 'O3'],
  allowedConfSparts: ['Z1', 'Z2'],
  allowedWearTypes: ['top', 'bottom'],
  topEditableSizes: ["36", "46", "48", "50"],
  bottomEditableSizes: ["42", "44"],
}

export const isSFAUser = (confvalue) => {
  return String(confvalue?.isSFA) === "1";
  // console.log(user);
  // return false;
}
